export default __webpack_public_path__ + "e9cc2f5b81a7301c4680f3e57b0cc9b4.png";